function observeElementsInView(selector, className) {
    const elements = document.querySelectorAll(selector);
    
    const observer = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
            if (entry.isIntersecting) {
                entry.target.classList.add(className);
                observer.unobserve(entry.target);
            }
        });
    }, {
        root: null,
        rootMargin: "100px",
        threshold: 1.0
    });
    
    elements.forEach((element) => {
        observer.observe(element);
        // console.log("Observing element:", element);
        
    });
}


setTimeout(() => {
    observeElementsInView('.animateSVG', 'animate');
    observeElementsInView('.twoColumns__icon', 'animate');
    observeElementsInView('.text__icon', 'animate');
    observeElementsInView('.textWithShare__iconSVG', 'animate');
    observeElementsInView('.lineToAnimate', 'animate');
}, 500);